import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { merchantListRequest } from '../../../redux/merchant/merchant.action'
import { addSuppliesItemRequest, addSuppliesItemRequestStatus } from '../../../redux/supplies/supplies.action'
import { displayErrorToast, isEmpty } from "../../../utils/Utils";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';

const AddSuppliesItem = props => {
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { merchantListSuccess, merchantListError } = useSelector(state => state.merchant)
    const { addSuppliesItemSuccess, addSuppliesItemError, addSuppliesItemReqStatus } = useSelector(state => state.supplies)
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [isSellable, setIsSellable] = useState(false)
    const [price, setPrice] = useState('')
    const [cost, setCost] = useState('')
    const [perItemCost, setPerItemCost] = useState('')
    const [quantity, setQuantity] = useState('')
    const [quantityThreshold, setQuantityThreshold] = useState('')
    const [sku, setSku] = useState('')
    const [isActive, setIsActive] = useState(false)
    const [selectedMerchant, setSelectedMerchant] = useState()
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        fetchMerchantList()
    }, [])

    useEffect(() => {
        if (!isEmpty(merchantListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(merchantListError)) {
            setLoading(false)
        }
    }, [merchantListSuccess, merchantListError])

    useEffect(() => {
        if (addSuppliesItemReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addSuppliesItemReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addSuppliesItemError.message)
        }
        if (addSuppliesItemReqStatus?.length) {
            dispatch(addSuppliesItemRequestStatus(''))
        }
    }, [addSuppliesItemSuccess, addSuppliesItemError, addSuppliesItemReqStatus])

    const fetchMerchantList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId,
            locationId: state.locationId
        }
        dispatch(merchantListRequest(data))
    }

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Name cannot be blank')
        } else if (isEmpty(cost)) {
            displayErrorToast('Item cost cannot be blank')
        } else if (parseFloat(cost) < 0) {
            displayErrorToast('Invalid item cost')
        } else if (isEmpty(perItemCost)) {
            displayErrorToast('Per item cost cannot be blank')
        } else if (parseFloat(perItemCost) < 0) {
            displayErrorToast('Invalid per item cost')
        } else if (isEmpty(sku)) {
            displayErrorToast('SKU cannot be blank')
        } else if (isSellable === true && isEmpty(price)) {
            displayErrorToast('Selling price cannot be blank')
        } else if (isEmpty(selectedMerchant)) {
            displayErrorToast('Merchant not selected')
        } else if (isEmpty(quantity)) {
            displayErrorToast('Quantity cannot be blank')
        } else if (parseFloat(quantity) < 0) {
            displayErrorToast('Invalid quantity')
        } else if (isEmpty(quantityThreshold)) {
            displayErrorToast('Reorder threshold cannot be blank')
        } else if (parseFloat(quantityThreshold) < 0) {
            displayErrorToast('Invalid reorder threshold')
        } else {
            setLoading(true)
            const data = {
                name: name,
                locationId: state.locationId,
                businessId: state.businessId,
                merchantId: selectedMerchant.merchantId,
                suppliesCategoryId: state.suppliesCategoryId,
                cost: parseFloat(cost),
                perItemCost: parseFloat(perItemCost),
                stock: parseFloat(quantity),
                reorderThreshold: parseFloat(quantityThreshold),
                sku: sku,
                isActive: isActive,
                isSellable: isSellable,
                productCode: APP_CONSTANTS.PRODUCT_NAME
            }
            if (!isEmpty(description)) {
                data.description = description
            }
            if (isSellable) {
                data.price = parseFloat(price)
            }
            dispatch(addSuppliesItemRequest(data))
        }
    }

    const clearFields = () => {
        setName('')
        setDescription('')
        setIsSellable(false)
        setPrice('')
        setCost('')
        setPerItemCost('')
        setQuantity('')
        setQuantityThreshold('')
        setSku('')
        setIsActive(false)
        setShowSuccessModal(false)
    }

    const handleAddNewItemClick = () => {
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Add Item' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new supplies item' />
                    <div className="asi-cat-name-label">{state.categoryName}</div>
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Name'
                        value={name} />
                    <CommonInputFloatFull
                        type='text'
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Description'
                        value={description}
                        multiline={true}
                        rows={3} />
                    <CommonInputFloatFull
                        type='text'
                        id='sku'
                        onChange={e => setSku(e.target.value)}
                        placeholder='SKU'
                        value={sku} />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='cost'
                            onChange={e => setCost(e.target.value)}
                            placeholder='Cost'
                            value={cost} />
                        <CommonInputFloatHalf
                            type='number'
                            id='perItemCost'
                            onChange={e => setPerItemCost(e.target.value)}
                            placeholder='Per Item Cost'
                            value={perItemCost} />
                    </CommonInputRow>
                    <CommonCheckbox
                        id='isSellable'
                        label='Is item sellable'
                        value={isSellable}
                        onChange={() => {
                            setIsSellable(!isSellable)
                        }}
                    />
                    {isSellable && <CommonInputFloatFull
                        type='number'
                        id='price'
                        onChange={e => setPrice(e.target.value)}
                        placeholder='Price'
                        value={price} />}
                    <CommonCheckbox
                        id='isActive'
                        label='Is active'
                        value={isActive}
                        onChange={() => {
                            setIsActive(!isActive)
                        }}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='quantity'
                            onChange={e => setQuantity(e.target.value)}
                            placeholder='Quantity'
                            value={quantity} />
                        <CommonInputFloatHalf
                            type='number'
                            id='quantityThreshold'
                            onChange={e => setQuantityThreshold(e.target.value)}
                            placeholder='Reorder Threshold'
                            value={quantityThreshold} />
                    </CommonInputRow>
                    <FormFieldLabel label='Select Merchant' />
                    {merchantListSuccess && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectedMerchant}
                        getOptionLabel={e => `${e.name} - ${e.isActive ? 'Active' : 'In-Active'}`}
                        getOptionValue={e => e}
                        options={merchantListSuccess.data}
                        placeholder='Select Merchant'
                        onChange={e => {
                            setSelectedMerchant(e)
                        }} />}
                    {!isEmpty(merchantListError) && <div className="content-error">{merchantListError.message}</div>}
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addSuppliesItemSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another item?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleAddNewItemClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddSuppliesItem